var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSharpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.075,
    height: 22.959,
    viewBox: "0 0 24.075 22.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28911",
    "data-name": "Group 28911",
    transform: "translate(-1305.925 -1091.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star-sharp-svgrepo-com",
    d: "M13.994,4.556c.308-.887.462-1.33.69-1.453a.666.666,0,0,1,.632,0c.228.123.382.566.69,1.453l2.038,5.864a1.516,1.516,0,0,0,.211.473.666.666,0,0,0,.259.189,1.516,1.516,0,0,0,.515.054l6.206.126c.939.019,1.408.029,1.6.208a.666.666,0,0,1,.2.6c-.046.255-.42.538-1.169,1.106l-4.947,3.75a1.52,1.52,0,0,0-.384.346.667.667,0,0,0-.1.305,1.518,1.518,0,0,0,.107.506l1.8,5.942c.272.9.408,1.348.3,1.582a.666.666,0,0,1-.511.372c-.257.034-.642-.234-1.413-.77l-5.1-3.546a1.521,1.521,0,0,0-.448-.259.667.667,0,0,0-.321,0,1.521,1.521,0,0,0-.448.259L9.3,25.209c-.771.536-1.156.8-1.413.77a.666.666,0,0,1-.511-.372c-.112-.233.024-.683.3-1.582l1.8-5.942a1.517,1.517,0,0,0,.107-.506.667.667,0,0,0-.1-.305,1.52,1.52,0,0,0-.384-.346l-4.947-3.75c-.748-.567-1.122-.851-1.169-1.106a.666.666,0,0,1,.2-.6c.187-.179.657-.188,1.6-.208l6.207-.126a1.516,1.516,0,0,0,.515-.054.666.666,0,0,0,.259-.189,1.516,1.516,0,0,0,.211-.473Z",
    transform: "translate(1302.962 1088.543)",
    fill: "#cfcfcf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSharpWhite);
export default __webpack_public_path__ + "static/media/star-sharp-white.45cf9f59618ce2a4e09b456252645dfa.svg";
export { ForwardRef as ReactComponent };